import appleIcon from '../../assets/appleIcon.svg';
import './AppleLoginButton.css';
import { useBrandContext } from '../../context/BrandContext';
import { isWebView } from '../../utils/detectWebContainer';

const AppleLoginButton = () => {
  const brandContext = useBrandContext();

  const webViewLogin = () => {
    window.ReactNativeWebView?.postMessage(
      JSON.stringify({ type: 'APPLE_AUTH' })
    );
  };

  const login = () => {
    const brand = brandContext.brandName;
    const webView = isWebView();

    if (webView) {
      webViewLogin();
      return;
    }

    const redirectUriValue = `${process.env.REACT_APP_API_URL}/authApple/callback`;

    const state = encodeURIComponent(
      JSON.stringify({
        frontendRedirect: webView
          ? `https://app.spott.eco/${brand}/app`
          : `${window.location.origin}/${brand}`,
        flowName: 'GeneralOAuthFlow',
      })
    );

    const appleUrl =
      'https://appleid.apple.com/auth/authorize' +
      `?client_id=${process.env.REACT_APP_APPLE_CLIENT_ID}` +
      `&redirect_uri=${encodeURIComponent(redirectUriValue)}` +
      '&response_type=code%20id_token' +
      '&response_mode=form_post' +
      `&state=${state}` +
      `&nonce=unused` +
      `&scope=name%20email`;

    window.location.href = appleUrl;
  };

  return (
    <button type='button' className='apple-login-button' onClick={login}>
      <img alt='apple-icon' src={appleIcon} />
      Continuar com Apple
    </button>
  );
};

export default AppleLoginButton;
